<script lang="ts">
	import { DefaultLoading } from "@hitit/new_ui/src";

	export let coverMode = false;
	export let blockMode = false;
	export let coverColor = `rgba(240,240,244,0.6)`;

</script>

{#if coverMode}
	<div class="cover" style={`background-color : ${coverColor}`}>
		<div class="container">
			<DefaultLoading />
		</div>
	</div>
{:else if blockMode}
	<div class="block">
		<div class="container">
			<DefaultLoading />
		</div>
	</div>
{:else}
	<div class="container">
		<DefaultLoading />
	</div>
{/if}

<style lang="scss">
	.block {
		width: 100%;
		height: 30px;
		position: relative;
	}

	.container {
		width: 30px;
		height: 30px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.cover {
		top: 0px;
		left: 0px;
		bottom: 0px;
		right: 0px;
		position: absolute;
		z-index: 99;
	}

</style>
